<template>
  <div>
    <div class="bg-white rounded-10px elshadow w-full p-6 mt-5">
      <div class="grid grid-cols-2 gap-5 w-full mb-3">
        <div class="flex gap-2 items-center w-full">
          <div class="w-2/12">
            <p class="text-dark fsize12">Status</p>
          </div>
          <div class="w-10/12">
            <el-select
              v-model="selectedIssueStatus"
              placeholder="Select"
              collapse-tags
              class="w-full pr-8"
            >
              <el-option
                v-for="item in issueStatusoptions"
                :key="item.issueStatus"
                :label="item.issueStatus"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- <div class="flex gap-2 items-center w-full">
          <div class="w-3/12">
            <p class="text-dark fsize12">Issue Type</p>
          </div>
          <div class="w-9/12">
            <el-select
              v-model="selectedIssueType"
              collapse-tags
              placeholder="Select"
              class="w-full"
            >
              <el-option
                v-for="item in issueTypeoptions"
                :key="item.issueType"
                :label="item.issueType"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </div>
        </div> -->
      </div>
      <!-- <ReportBugSidebar
        :isSidebarActive="openReportBugSidebar"
        @closeSidebar="toggleReportBugSidebar"
        :selectedCase="selectedCase"
      /> -->
      <div class="w-full fixed-top bg-white p-6 rounded-t-2xl ht4-5rem flex">
        <div class="flex justify-between items-center w-full">
          <div class="cursor-pointer" @click="backToStories">
            <!-- <div class="flex items-center">
            <i class="text-primary font-bold fas fa-angle-left text-lg"></i>
            <p class="text-xs font-semibold ml-2 mb-0">Back to user stories</p>
          </div> -->
          </div>
          <!-- <div class="flex items-center">
          <p class="text-xs font-semibold">{{ selectedComponent.name }}</p>
          <div class="h-2 w-2 rounded-full mx-2 bg-f4f5f6"></div>
          <p class="text-xs font-semibold">ER00001</p>
          <div class="h-2 w-2 rounded-full mx-2 bg-f4f5f6"></div>
          <p class="text-xs font-semibold">{{ selectedSprint.name }}</p>
          <div class="h-2 w-2 rounded-full mx-2 bg-f4f5f6"></div>
          <p class="text-xs font-semibold">E-commerce</p>
        </div> -->
          <!-- <div>
          <base-button
            filled
            type=""
            class="rounded-full py-2 px-6 text-white bg-primary text-xs"
            @click="ReportBug"
            >Report Bug</base-button
          >
        </div> -->
        </div>
      </div>

      <el-table
        :data="this.newdata"
        border
        style="width: 100%"
        height="450px"
        class="table-responsive table-flush cust-overflow-x-primary-color"
        header-row-class-name="thead-light table-th-color"
      >
        <el-table-column prop="city" label="Issue ID" min-width="90px">
          <template v-slot="{ row }">
            <P class="text-gray fsize12">{{ row.issueId }}</P>
          </template>
        </el-table-column>
        <el-table-column prop="city" label="Module" min-width="150px">
          <template v-slot="{ row }">
            <div class="flex justify-center items-center border-warning4">
              <P class="text-warning fsize10 m-0 text-center">{{
                row.moduleName.moduleName
              }}</P>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="city" label="Issue" min-width="150px">
          <template v-slot="{ row }">
            <P class="text-gray fsize12">{{ row.issueName }}</P>
          </template>
        </el-table-column>
        <el-table-column prop="city" label="Found On" min-width="150px">
          <!-- <template v-slot="{ row }">
            <div v-if="row.hasOwnProperty('foundOn')">
              <P
                v-for="index in row.foundOn"
                :key="index"
                class="text-gray fsize12"
                >{{ index.foundOn }}</P
              >
            </div>
          </template> -->
          <template v-slot="{ row }">
            <div class="flex gap-2 flex-wrap">
              <el-tag
                v-for="item in row.foundOn"
                :key="item"
                class="text-gray rounded-full"
                type="success"
                >{{ item.foundOn.foundOn }}</el-tag
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="city" label="Priority" min-width="150px">
          <template v-slot="{ row }">
            <P class="text-gray fsize12">{{
              row.priority ? row.priority.priority : ""
            }}</P>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="city" label="Issue type" min-width="150px">
          <template v-slot="{ row }">
            <div
              class="flex justify-center items-center border-warning4"
              v-if="row.issueType"
            >
              <P class="text-warning fsize10 m-0 text-center">{{
                row.issueType ? row.issueType.issueType : ""
              }}</P>
            </div>
            <div class="flex justify-center items-center" v-else>
              <P class="text-warning fsize10 m-0 text-center">{{ "" }}</P>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="city" label="Reported On" min-width="150px">
          <template v-slot="{ row }">
            <P class="fsize12">{{ getDate(row.createdAt) }}</P>
          </template>
        </el-table-column>

        <!-- <el-table-column width="250px" label="Scenario" prop="scenario">
      </el-table-column> -->
        <!-- <el-table-column width="250px" label="Test Cases" prop="testcase">
      </el-table-column>
      <el-table-column width="260px" label="Expected Result" prop="expected">
      </el-table-column> -->
        <el-table-column width="120px" label="Status" prop="status">
          <template v-slot="{ row }">
            <p
              class="text-danger"
              :class="{
                'text-success': row.issueStatus.issueStatus === 'Done',
              }"
            >
              {{ row.issueStatus ? row.issueStatus.issueStatus : "" }}
            </p>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="city" label="Options" min-width="150px">
        <template slot-scope="">
          <P class="text-warning fsize12 border-warning4">Report a bug</P>
        </template>
      </el-table-column> -->
      </el-table>
      <!-- <div class="whitenowrap mt-2 flex justify-end">
        <el-pagination
          background
          layout="prev,pager,next"
          class="rem-nowrap"
          :total="countData"
          :page-size="perPage"
        ></el-pagination>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
import Repository from "@/builder/apis/Repository";
import ReportBugSidebar from "./ReportBugSidebar.vue";
import { mapState } from "vuex";
import moment from "moment";
export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    ReportBugSidebar,
  },
  data() {
    return {
      newdata: [
        // {
        //   page: "001",
        //   scenario:
        //     "As a Customer on Register page i can Enter the First name, Last name, Mobile Number, Confirm Password, OTP and accepting the terms and conditions.",
        //   testcase: "Test case for entering valid inputs",
        //   expected: "User should be registered successfully",
        //   status: "Pass",
        // },
        // {
        //   page: "001",
        //   scenario:
        //     "As a Customer on Register page i can Enter the First name, Last name, Mobile Number, Confirm Password, OTP and accepting the terms and conditions.",
        //   testcase: "Test case for leaving any mandatory feild blank",
        //   expected:
        //     "Display an error message asking the user to fill in the mandatory feild",
        //   status: "Fail",
        // },
        // {
        //   page: "001",
        //   scenario:
        //     "As a Customer on Register page i can Enter the First name, Last name, Mobile Number, Confirm Password, OTP and accepting the terms and conditions.",
        //   testcase: "Test case for entering valid inputs",
        //   expected: "User should be registered successfully",
        //   status: "Pass",
        // },
        // {
        //   page: "001",
        //   scenario:
        //     "As a Customer on Register page i can Enter the First name, Last name, Mobile Number, Confirm Password, OTP and accepting the terms and conditions.",
        //   testcase: "Test case for leaving any mandatory feild blank",
        //   expected:
        //     "Display an error message asking the user to fill in the mandatory feild",
        //   status: "Fail",
        // },
      ],
      page: 1,
      offset: 0,
      limit: 10,
      loadData: false,
      openReportBugSidebar: false,
      taskList: [],
      tasks: [],
      selectedCase: {},
      optionstc: [
        { value: "A", text: "Scenerio" },
        { value: "B", text: "Test cases" },
        { value: "C", text: "Scenerio2" },
        { value: "D", text: "Text cases2" },
      ],
      selected: "A",
      selectedT: "B",
      issueStatusoptions: [],
      selectedIssueStatus: {},
      issueTypeoptions: [],
      selectedIssueType: {},
    };
  },

  methods: {
    backToStories() {
      this.$router.push({ name: "stories" });
      this.$store.commit("design/SET_SHOW_WIREFRAME_TAB", false);
    },
    toggleReportBugSidebar(val = false) {
      this.openReportBugSidebar = val;
    },
    ReportBug(item) {
      this.selectedCase = item;
      this.toggleReportBugSidebar(true);
    },

    async getTestCases() {
      return new Promise(async (resolve, reject) => {
        let loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        try {
          const { data } = await Repository.post("uibuilder/getTestCases", {
            projectName: "testApplication1",
            tasklist: this.selectedSprint._id,
            pageID: this.selectedComponent._id,
          });
          this.tableData = data.data.Record;
          console.log(data);
          resolve(data);
          loader.close();
        } catch (error) {
          reject(error);
          loader.close();
        }
      });
    },
    async getIssueListOnMount() {
      let payload = {
        tasklistID: this.selectedSprint._id,
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        isDeleted: false,
      };
      let data = await this.$store.dispatch(
        "issueTracker/getIssueList",
        payload
      );
      console.log(data.data, "issuelist");
      this.newdata = data.data;
      this.$emit("func", false);
    },
    async getIssueListbyIssueStatus(value) {
      let payload = {
        tasklistID: this.selectedSprint._id,
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        isDeleted: false,
        issueStatus: value,
      };
      let data = await this.$store.dispatch(
        "issueTracker/getIssueList",
        payload
      );
      console.log(data.data, "issuelist");
      this.newdata = data.data;
    },
    // async getIssueListbyIssueType(value) {
    //   let payload = {
    //     tasklist: this.selectedSprint._id,
    //     projectId: this.selectedProject._id,
    //     projectName: this.selectedProject.projectName,
    //     isDeleted: false,
    //     issueStatus: this.selectedIssueStatus,
    //     issueType: value,
    //   };
    //   let data = await this.$store.dispatch(
    //     "issueTracker/getIssueList",
    //     payload
    //   );
    //   console.log(data.data, "issuelist");
    //   this.newdata = data.data;
    // },
    async getIssueStatusList() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      let data = await this.$store.dispatch(
        "issueTracker/getIssueStatusList",
        payload
      );
      console.log(data.data, "issuestatus");
      this.issueStatusoptions = data.data;
      this.selectedIssueStatus = data.data[0]._id;
    },
    async getIssueTypeList() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      let data = await this.$store.dispatch(
        "issueTracker/getIssueTypeList",
        payload
      );
      console.log(data.data, "issuestatus");
      this.issueTypeoptions = data.data;
      this.selectedIssueType = data.data[0]._id;
    },
    getDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
  },
  async mounted() {
    await this.getTestCases();
    if (this.fetchData === true) {
      await this.getIssueListOnMount();
    }
    await this.getIssueListOnMount();
    await this.getIssueStatusList();
    await this.getIssueTypeList();
  },
  props: {
    fetchData: { type: Boolean },
  },

  computed: {
    ...mapState("design", ["selectedSprint", "selectedComponent"]),
    ...mapState("user", ["selectedProject", "brainedUserDetails"]),
  },
  watch: {
    async selectedIssueStatus(value) {
      await this.getIssueListbyIssueStatus(value);
    },
    async fetchData(value) {
      console.log(value, "fetch Data");
      if (value === true) {
        await this.getIssueListOnMount();
      }
    },
    // async selectedIssueType(value) {
    //   await this.getIssueListbyIssueType(value);
    // },
  },
};
</script>
<style>
.cust-bg-lightgrey-cntr th {
  background-color: #f4f5f6 !important;
  padding: 18px 0px;
  font-size: 12px;
  line-height: 20px;
  font-weight: 600;
  color: #282828;
}
</style>
